"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasModelSigner = void 0;
const ethers_1 = require("ethers");
const transactions_1 = require("@ethersproject/transactions");
class GasModelSigner extends ethers_1.Wallet {
    constructor(privateKey, provider, nodeAddress, expiration) {
        super(privateKey, provider);
        this.nodeAddress = nodeAddress;
        this.expiration = expiration;
    }
    signTransaction(transaction) {
        return ethers_1.ethers.utils.resolveProperties(transaction).then((tx) => {
            if (tx.from !== null) {
                delete tx.from;
            }
            const value = ethers_1.ethers.utils.defaultAbiCoder
                .encode(["address", "uint256"], [this.nodeAddress, this.expiration]);
            tx.data = tx.data + value.substring(2);
            tx.chainId = 0;
            const signature = this._signingKey().signDigest(ethers_1.ethers.utils.keccak256((0, transactions_1.serialize)(tx)));
            return (0, transactions_1.serialize)(tx, signature);
        });
    }
}
exports.GasModelSigner = GasModelSigner;
